import { VideoModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import RequireCss from '@helpers/RequireCss';
import Picture from '@atoms/pictures/Picture';
import Icon from '@atoms/icons/Icon';
import RequireJs from '@helpers/RequireJs';

type Props = {
  carouselSubHeader?: string;
  tabIndex?: number;
} & VideoModel;

const Video = (model: Props) => {
  const { videoId, thumbnail, subHeader, source, header } = model;
  const styleModifiers = getModifiers(model, 'kf-o-video');

  return (
    <div className={styleModifiers} data-source={source} data-video-id={videoId}>
      <div className="kf-container">
        <h3 className="kf-o-video__header">{header}</h3>
        <p className="kf-o-video__subheader">{subHeader}</p>
        <button aria-label={header} className="kf-o-video__thumbnail-container">
          <Picture {...thumbnail} />
          <span className="kf-o-video__play-icon">
            <Icon iconPath="#kf-play-arrow" viewBoxHeight={40} viewBoxWidth={40} />
          </span>
        </button>
      </div>
      {source === 'youtube' && <RequireJs async={true} defer={false} path="vendors/youtube/iframe_api" />}
      {source === 'vimeo' && <RequireJs async={true} defer={false} path="vendors/vimeo@2.23.0/player" />}

      <RequireCss path={'b-video'} />
      <RequireJs defer path={'video'} />
    </div>
  );
};

export default Video;
